import dashboardLinks from './dashboardLinks';

export default dashboardLinks;
